import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=266f3366"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266f3366')) {
      api.createRecord('266f3366', component.options)
    } else {
      api.reload('266f3366', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=266f3366", function () {
      api.rerender('266f3366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileUpload.vue"
export default component.exports